//Supplier Status
export const PS_STATUS_READY = 'Ready';
export const PS_STATUS_EVALUATING = 'Evaluating';
export const PS_STATUS_PENDING = 'Pending';
export const PS_STATUS_DONOTADD = 'Do Not Add';

export const SPLR_TYPE_NON_CURRENT = 'Non-Current';
export const SPLR_TYPE_CURRENT = 'Current';

export const EDITABLE_CURRENT_PS_COLUMNS = ['status', 'comments'];
export const EDITABLE_NON_CURRENT_PS_COLUMNS = [
  ...EDITABLE_CURRENT_PS_COLUMNS,
  'name',
  'city',
  'region',
  'country',
  'sdis'
];

export const AERatingToolTipText = 'Previous Rating Period';
export const SBM_TOOLTIP_TEXT = 'From SRO';
